import React from 'react';
import { Checkmark } from '@carbon/icons-react';
import { showToast } from '@ditioas/web-ui';

const showPlanningToast = (message: string) =>
  showToast(
    <p className="w-full select-none">
      <Checkmark className="float-end ml-2 fill-green-600" />
      {message}
    </p>,
    { data: { position: 'bottom-center' } }
  );

export default showPlanningToast;
